module.exports = __webpack_public_path__ + "img/clock.e1f4e872.svg";